setLiveAccessTrackError